'use client'
const defaultWalletUiUtils = {
    createPassword: () => {
        throw Error('createPassword not implemented');
    },
    disabledConfirmationOnce: () => {
        throw Error('disabledConfirmationOnce, not implemented');
    },
    enterPassword: () => {
        throw Error('enterPassword not implemented');
    },
    sendTransaction: () => {
        throw Error('requestSendTransactionConfirmation not implemented');
    },
    signMessage: () => {
        throw Error('signMessage not implemented');
    },
    signTransaction: () => {
        throw Error('signTransaction not implemented');
    },
    syncWallet: () => {
        throw Error('syncWallet not implemented');
    },
};

export { defaultWalletUiUtils };
